// @flow
import { all, fork, put, takeEvery, call } from 'redux-saga/effects';

import {
    getIncidencias as listIncidenciasAPI,
    getIncidencia as getIncidenciaAPI,
    addIncidencia as addIncidenciaAPI,
    updateIncidencia as updateIncidenciaAPI,
    deleteIncidencia as deleteIncidenciaAPI,
} from '../../helpers/';

// import { APICore, setAuthorization } from '../../helpers/api/apiCore';
import { incidenciasApiResponseError, incidenciasApiResponseSuccess } from './actions';
import { IncidenciasActionTypes } from './constants';

// const api = new APICore();

/**
 * Get contacto
 * @param {*} payload - username and password
 */
function* getIncidencia({ payload: { id } }) {
    try {
        const response = yield call(getIncidenciaAPI, id );
        const incidenciaItem = response.data.data;
        yield put(incidenciasApiResponseSuccess(IncidenciasActionTypes.GET_INCIDENCIA, incidenciaItem));
    } catch (error) {
        yield put(incidenciasApiResponseError(IncidenciasActionTypes.GET_INCIDENCIA, error));
    }
}

function* addIncidencia({payload:incidencia}){
    try{
        const response = yield call(addIncidenciaAPI,{...incidencia})
        const incidenciaItem = response.data
        yield put(incidenciasApiResponseSuccess(IncidenciasActionTypes.ADD_INCIDENCIA,incidenciaItem))
    } catch(error){
        yield put(incidenciasApiResponseError(IncidenciasActionTypes.ADD_INCIDENCIA,error))
    }
}

function* updateIncidencia({payload:incidencia}){
    try{
        const response = yield call(updateIncidenciaAPI,{...incidencia})
        const incidenciaItem = response.data.data
        yield put(incidenciasApiResponseSuccess(IncidenciasActionTypes.UPDATE_INCIDENCIA,incidenciaItem))
    }catch(error){
        yield put(incidenciasApiResponseError(IncidenciasActionTypes.UPDATE_INCIDENCIA,error))
    }
}
function* deleteIncidencia({payload:{id}}){
    try{
        const response = yield call(deleteIncidenciaAPI,id)
        const incidenciaItem = response.data.id
        yield put(incidenciasApiResponseSuccess(IncidenciasActionTypes.DELETE_INCIDENCIA,incidenciaItem))
    }catch(error){
        yield put(incidenciasApiResponseError(IncidenciasActionTypes.DELETE_INCIDENCIA,error))
    }
}

/**
 * List contactos
 */
function* listIncidencias({payload:params}) {
    try {
        const response = yield call(listIncidenciasAPI, { ...params });
        const listaIncidencias = response.data.data;
        yield put(incidenciasApiResponseSuccess(IncidenciasActionTypes.LIST_INCIDENCIAS, listaIncidencias));
    } catch (error) {
        yield put(incidenciasApiResponseError(IncidenciasActionTypes.LIST_INCIDENCIAS, error));
    }
}


export function* watchGetIncidencia(): any {
    yield takeEvery(IncidenciasActionTypes.GET_INCIDENCIA, getIncidencia);
}

export function* watchListIncidencias(): any {
    yield takeEvery(IncidenciasActionTypes.LIST_INCIDENCIAS, listIncidencias);
}

export function* watchAddIncidencia():any{
    yield takeEvery(IncidenciasActionTypes.ADD_INCIDENCIA,addIncidencia)
}
export function* watchUpdateIncidencia():any{
    yield takeEvery(IncidenciasActionTypes.UPDATE_INCIDENCIA,updateIncidencia)
}
export function* watchDeleteIncidencia():any{
    yield takeEvery(IncidenciasActionTypes.DELETE_INCIDENCIA,deleteIncidencia)
}


function* incidenciasSaga(): any {
    yield all([
        fork(watchGetIncidencia),
        fork(watchListIncidencias),
        fork(watchAddIncidencia),
        fork(watchUpdateIncidencia),
        fork(watchDeleteIncidencia),
    ]);
}

export default incidenciasSaga;
